export const LogType = {
  INFO: "success",
  DEBUG: "default",
  ERROR: "danger",
  WARNING: "warning"
};
